export const localeByLocaleId = {
	"en-au": {
		appUrl: process.env.REACT_APP_AU_APP_URL,
		currencyCode: "AUD",
		pathPrefix: process.env.REACT_APP_AU_PATH_PREFIX ?? "",
		webflowHomepageUrl:
			process.env.REACT_APP_WEBFLOW_AU_HOMEPAGE_URL ??
			`${process.env.REACT_APP_WEBFLOW_US_HOMEPAGE_URL}/${process.env.REACT_APP_AU_PATH_PREFIX}`,
	},
	"en-ca": {
		appUrl: process.env.REACT_APP_CA_APP_URL,
		currencyCode: "CAD",
		pathPrefix: process.env.REACT_APP_CA_PATH_PREFIX ?? "",
		webflowHomepageUrl:
			process.env.REACT_APP_WEBFLOW_CA_HOMEPAGE_URL ??
			`${process.env.REACT_APP_WEBFLOW_US_HOMEPAGE_URL}/${process.env.REACT_APP_CA_PATH_PREFIX}`,
	},
	"en-gb": {
		appUrl: process.env.REACT_APP_GB_APP_URL,
		currencyCode: "GBP",
		pathPrefix: "/en-gb",
		webflowHomepageUrl: `${process.env.REACT_APP_WEBFLOW_US_HOMEPAGE_URL}/en-gb`,
	},
	"en-us": {
		appUrl: process.env.REACT_APP_US_APP_URL,
		currencyCode: "USD",
		pathPrefix: "",
		webflowHomepageUrl: process.env.REACT_APP_WEBFLOW_US_HOMEPAGE_URL,
	},
};
